import { Attributes, DateUtils, Misc, NeoModel, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

@NeoModel
export default class RicosCriteria extends ValueObject {

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public runDate: Date | null = DateUtils.today();

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Ricos Criteria";
    }
}